import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";

import './App.scss';
import routes from "./routes";
import withTracker from "./withTracker";
import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "./assets/styles.css"
import axios from 'axios';
import  WebServiceList  from './webservices/WebServiceList'
import { UserProvider } from './contexts/UserContext'

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: {},
      redirect: false
    }
  }


  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to='/' />
    }
  }

  componentDidMount() {

    let isLoggedIn = localStorage.getItem("loggedIn");

    let theToken = localStorage.getItem("token");
    //let theToken ="fff"
    const headers = {
      'Content-Type': 'application/json',
      'x-access-token': theToken,
    };

    console.log("token:" + theToken);
    console.log("isLoggedIn:" + isLoggedIn);

    if (isLoggedIn) {
      axios.get(WebServiceList.WsGetAdminInfo(), { headers })
        .then(res => {
          console.log("componentDidMount " + JSON.stringify(res.data));
          if (res.data.success === true) {
            console.log("-------> connected");
            let theUser = res.data.admin;
            console.log("-------> theUser:"+JSON.stringify(theUser));
            this.setState({ user: theUser });
          } else {

            localStorage.setItem("token", "");
            localStorage.setItem("AdminId", "");
            localStorage.setItem("AdminEmail", "");
            localStorage.setItem("AdminName", "");
            localStorage.setItem("AdminRole", "");
            localStorage.setItem("loggedIn", false);
            this.setState({ redirect: true })
          }
        });
    }

  }

  render() {
    return (<UserProvider value={this.state.user} >
      <Router basename={process.env.REACT_APP_BASENAME || ""}>
        {this.renderRedirect()}
        <div>
          {routes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={withTracker(props => {
                  return (
                    <route.layout {...props}>
                      <route.component {...props} />
                    </route.layout>
                  );
                })}
              />
            );
          })}
        </div>
      </Router>
    </UserProvider>

    )
  }
}

export default App;
